class DeliveryPrices {
    constructor(data) {
        this.data = data.countries;
        this.init();
    }

    init() {
        this.cacheElements();
        this.populateCountrySelector();
        this.bindEvents();
        this.renderContent();
    }

    cacheElements() {
        this.$container = jQuery('#delivery-prices-container');
        this.$countrySelector = this.$container.find('#country-selector');
        this.$selectedCountry = this.$container.find('#selected-country');
        this.$selectedCountryText = this.$container.find('#selected-country-text');
        this.$selectedCountryEnvelope = this.$container.find('#selected-country-envelope');
        this.$parcelPrices = this.$container.find('#parcel-prices');
        this.$envelopePrices = this.$container.find('#envelope-prices');
    }

    populateCountrySelector() {
        const countries = Object.keys(this.data);
        countries.forEach(country => {
            this.$countrySelector.append(new Option(country, country));
        });
    }

    bindEvents() {
        this.$countrySelector.on('change', () => {
            this.renderContent();
        });
    }

    renderContent() {
        const country = this.$countrySelector.val() || 'Россия';
        const countryData = this.data[country];
        const countryDisplayName = countryData.destinationDisplay;

        // Update country text
        this.$selectedCountry.text(countryDisplayName);
        this.$selectedCountryText.text(countryDisplayName);
        this.$selectedCountryEnvelope.text(countryDisplayName);

        // Render tables
        this.renderParcelTable(countryData);
        this.renderEnvelopeTable(countryData);
    }

    renderParcelTable(countryData) {
        const prices = countryData.prices.parcel;
        const countryDisplayName = countryData.destinationDisplay;
        let priceOverLimit = '';
        if(countryData.prices.overWeight !== null) {
          priceOverLimit = countryData.prices.overWeight + ' THB за кг';
        }
        else {
          priceOverLimit = 'Рассчитывается индивидуально';
        }
        let tableHtml = '<table><thead><tr>';

        if (countryData.hasFarZones) {
            tableHtml += '<th>Вес, кг</th><th>Тариф на перевозку посылок от офиса Light Logistics в Таиланде до двери клиента в ' + countryDisplayName + '</th><th>Зона повышенной стоимости</th>';
        } else {
            tableHtml += '<th>Вес, кг</th><th>Тариф на перевозку посылок от офиса Light Logistics в Таиланде до двери клиента</th>';
        }

        tableHtml += '</tr></thead><tbody>';

        prices.forEach(range => {
            const weightText = range.max === null
                ? `Свыше ${range.min} кг`
                : range.min === range.max
                ? `${range.min} кг`
                : `${range.min} — ${range.max} кг`;

            tableHtml += '<tr>';
            tableHtml += `<td style="text-align: center;">${weightText}</td>`;
            tableHtml += `<td style="text-align: center;">${range.max !== null ? range.prices[0] + ' THB' : priceOverLimit }</td>`;

            if (countryData.hasFarZones) {
                tableHtml += `<td style="text-align: center;">${range.prices[1] ? range.prices[1] + ' THB' : ''}</td>`;
            }

            tableHtml += '</tr>';
        });

        tableHtml += '</tbody></table>';
        this.$parcelPrices.html(tableHtml);
    }

    renderEnvelopeTable(countryData) {
        if(!countryData.prices.envelope) {
          this.$envelopePrices.html('<p style="padding: 20px;">Для данной страны цены на пересылку корреспонденции отсутствуют</p>');
          return; }
        const prices = countryData.prices.envelope;
        let tableHtml = '<table><thead><tr>';
        tableHtml += '<th>Вес, кг</th><th>Тариф на перевозку корреспонденции курьером в руки получателю</th>';
        tableHtml += '</tr></thead><tbody>';

        prices.forEach(range => {
            const weightText = `${range.min} кг`;
            tableHtml += '<tr>';
            tableHtml += `<td style="text-align: center;">${weightText}</td>`;
            tableHtml += `<td style="text-align: center;">${range.prices[0]} THB</td>`;
            tableHtml += '</tr>';
        });

        tableHtml += '</tbody></table>';
        this.$envelopePrices.html(tableHtml);
    }
}

export default DeliveryPrices;
